// extracted by mini-css-extract-plugin
module.exports = {"header":"Header_header__1VCKf","link":"Header_link__2wI74"};